var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"scrollUp"}},[_c('div',{staticClass:"scroll-up",on:{"click":_vm.scrollToTop}},[_vm._v(" Remonter")])])}
var staticRenderFns = []

export { render, staticRenderFns }